import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

const vuexLocalStorage = new VuexPersist({
  key: 'relatorios',
  storage: window.localStorage,
})

Vue.use(Vuex)

const actions = {}

export default new Vuex.Store({
  state: {
    contratoId: '',
    dataSelecionada: '',
    prestador: {},
    abasExibir: {
      exibirFontePagadoraProducao: false,
      exibirOperadoraProducao: false,
      exibirRecebimentoConciliacao: false,
    },
    profissionalExecutante: {},
  },
  getters: {
    CONTRATO_ID: (state: any) => state.contratoId,
    DATA_SELECIONADA: (state: any) => state.dataSelecionada,
    PRESTADOR: (state: any) => state.prestador,
    PROFISSIONAL_EXECUTANTE: (state: any) => state.profissionalExecutante,
    ABAS_EXIBIR: (state: any) => state.abasExibir,
  },
  actions,
  mutations: {
    CONTRATO_ID(state: any, newContratoId: any) {
      state.contratoId = newContratoId
    },
    ABAS_EXIBIR(state: any, value: any) {
      state.abasExibir = value
    },
    DATA_SELECIONADA(state: any, newDataSelecionada) {
      state.dataSelecionada = newDataSelecionada
    },
    PRESTADOR(state: any, newPrestador) {
      state.prestador = newPrestador
    },
    PROFISSIONAL_EXECUTANTE(state: any, newProfissionalExecutante) {
      state.profissionalExecutante = newProfissionalExecutante
    },
  },
  plugins: [
    vuexLocalStorage.plugin,
  ],
})
